import { Coberturas, SegmentoSimulacao, Seguradoras } from "#/enums";
import { TCoberturas } from "#/types/ofertas";
import {
  assistencia,
  carroReserva,
  danosCorporais,
  danosMateriais,
  danosMorais,
  invalidezEMorte,
  seguroTotal,
  vidros,
} from "./descricaoCoberturasItens";

export const descricaoCoberturas: { [key: string]: TCoberturas[] } = {
  [SegmentoSimulacao.BASICO.toLocaleLowerCase()]: [
    {
      seguradora: Seguradoras.ALIRO,
      coberturas: [
        seguroTotal,
        danosMateriais,
        danosCorporais,
        assistencia,
        vidros,
      ],
    },
    {
      seguradora: Seguradoras.YELUM,
      coberturas: [
        seguroTotal,
        danosMateriais,
        danosCorporais,
        danosMorais,
        invalidezEMorte,
        assistencia,
        vidros,
        carroReserva,
      ],
    },
  ],
  [SegmentoSimulacao.INTERMEDIARIO.toLocaleLowerCase()]: [
    {
      seguradora: Seguradoras.ALIRO,
      coberturas: [
        seguroTotal,
        danosMateriais,
        danosCorporais,
        danosMorais,
        invalidezEMorte,
        assistencia,
        vidros,
      ],
    },
    {
      seguradora: Seguradoras.YELUM,
      coberturas: [
        seguroTotal,
        danosMateriais,
        danosCorporais,
        danosMorais,
        invalidezEMorte,
        assistencia,
        vidros,
        carroReserva,
      ],
    },
  ],
  [SegmentoSimulacao.AVANCADO.toLocaleLowerCase()]: [
    {
      seguradora: Seguradoras.ALIRO,
      coberturas: [
        seguroTotal,
        danosMateriais,
        danosCorporais,
        danosMorais,
        invalidezEMorte,
        assistencia,
        vidros,
        carroReserva,
      ],
    },
    {
      seguradora: Seguradoras.YELUM,
      coberturas: [
        seguroTotal,
        danosMateriais,
        danosCorporais,
        danosMorais,
        invalidezEMorte,
        assistencia,
        vidros,
        carroReserva,
      ],
    },
  ],
};

export const DESCRICAO_COBERTURAS = {
  modalidade: Coberturas.MODALIDADE,
  dano_material: Coberturas.DANOS_MATERIAIS,
  dano_corporal: Coberturas.DANOS_CORPORAIS,
  dano_morais: Coberturas.DANOS_MORAIS,
  invalidez: Coberturas.INVALIDEZ,
  morte: Coberturas.MORTE,
};
